import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Admin settings have moved inline onto every page.
// This route is kept for backward compatibility and just redirects.
const AdminRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/work', { replace: true });
  }, [navigate]);
  return null;
};

export default AdminRedirect;
